export const Header = () => {
  return (
    <div className='header-wrapper'>
      <div className='header'>
        AI Text to<span> Speech</span>
      </div>
      <label>Powered by OpenAI</label>
    </div>
  );
};
